export const dayjsTypes = {
  dateType: 'DD.MM.YYYY',
}
